export const iconFontAwesomeCodingShield = (
	<i className="fa-solid fa-shield"></i>
);
